import { listChatSeedStrategies } from './registry';
import type {
  ChatSeedPreSubmitContext,
  ChatSeedPreSubmitResult,
  ChatSeedSubmitParams,
} from './types';

/** Invoke each strategy's `preSubmit` until one applies (non-null result). */
export async function runChatSeedPreSubmitForSubmitParams(
  params: ChatSeedSubmitParams,
  ctx: Omit<ChatSeedPreSubmitContext, 'params'>
): Promise<ChatSeedPreSubmitResult | null> {
  for (const strategy of listChatSeedStrategies()) {
    if (strategy.preSubmit === undefined) {
      continue;
    }

    const result = await strategy.preSubmit({ ...ctx, params });
    if (result !== null) {
      return result;
    }
  }

  return null;
}
